
<template>

    <section class="software-requests">

        <div class="panel">
            <div class="panel-heading">
                <h2>Software Request Form</h2>
            </div>
            <div class="panel-body" v-if="software && selectionAvailable === true">
                <div class="text" v-if="text && text.disclaimer" v-html="text.disclaimer[0].text">
                    
                </div>
                <label class="confirmation">I've read and understand these instructions<input type="checkbox" v-model="instructionsConfirmed"></label>

                <div  v-if="instructionsConfirmed">
                    <ul class="software">
                        <li v-for="program in software">
                            <div>
                                <img :src="program.icon">
                                <h4>{{program.name}} <span v-if="paymentRequired === true">({{program.price | currency}}) CAD</span></h4>
                            </div>
                            <div>
                                <select v-if="!hasSelectedSoftware" @change="selectSoftware(program.id, $event)" class="form-control select-software">
                                    <option value="true">I'll Need this for Next Term</option>
                                    <option value="false">I've Already Purchased This</option>

                                </select>
                                <span v-else>Please check the <router-link to="/software-keys">Keys</router-link> page for your software keys</span>
                            </div>
                        </li>
                    </ul>
                    <div class="subtotal" v-if="!hasSelectedSoftware">
                        <h4>
                            <span v-if="paymentRequired === true">Subtotal: {{subTotal | currency}} CAD</span>
                        </h4>
                        <button class="btn btn-success" @click.prevent="submitRequest()">Confirm Needed Software</button>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-if="selectionAvailable === false">
                <div class="text">
                    <p v-html="htmlify(message)"></p>    
                </div>

            </div>
        </div>
    </section>

</template>

<script>

import software from '../services/software';
import cms from '../services/cms';

import toastr from 'toastr';
import { groupBy } from 'lodash';
import linkifyHtml from 'linkifyjs/html';

export default {
    data() {
        return {
            software:null,
            selected: [],
            hasSelectedSoftware: false,
            paymentRequired: false,
            text:null,
            instructionsConfirmed: false,
            selectionAvailable: null,
            message: null
        }
    },
    components: {

    },
    mounted() {
        this.checkAvailability().then((response)=>{
            if (response.data.softwareAvailable === true) {
                this.selectionAvailable = true;
                this.getSoftware();        
            } else {
                this.selectionAvailable = false;
                this.message = response.data.message;                
            }
        });
        this.getText();
        
    },
    methods: {
        htmlify(str) {
            return linkifyHtml(str)
        },
        checkAvailability() {
            return software.checkAvailability().then((response) => {
                return response;
            });
        },
        getText() {
            cms.get('SoftwareRequests').then((response)=> {
                this.text = groupBy(response.components, (c)=> { return c.name });
            });
        },
        getSoftware() {
            software.getSoftware().then((response)=> {
                console.log(response)
                this.software = response.data.software;
                this.selected = this.software.map((s)=> { return s.id });

                const hasSelectedSoftware = this.software.find((s)=> { return s.software_needs.length > 0})
                if (hasSelectedSoftware) { this.hasSelectedSoftware = true; }

                this.paymentRequired = response.data.paymentRequired;
            });
        },
        selectSoftware(id, $event) {
            if ($event.target.value == 'true') {
                this.selected.push(id);
            } else {
                let index = this.selected.findIndex((s)=> { return s === id});
                this.selected.splice(index, 1)
            }
        },
        submitRequest() {
            this.$store.dispatch('toggle', { type: 'loading', boolean: true });

            const softwareNames = this.software.filter((s)=> { return this.selected.includes(s.id)}).map((s)=>{ return s.name});
            
            software.createNeeds(this.selected, softwareNames).then((response)=> {

                this.$store.dispatch('toggle', { type: 'loading', boolean: false });

                if (response.data.success === true) {
                    toastr.success('Request submitted');
                    this.getSoftware();
                } else {                    
                    toastr.error(response.data.message || 'Error submitting request');
                }
            });
        }

    },
    computed: {
        subTotal() {
            let selected = this.software.filter((s)=> {
                return this.selected.includes(s.id);
            }).map((s)=> {
                return s.price
            });
            if (selected.length > 0) {
                return selected.reduce((a,b)=> { return a + b})
            }
            return 0;
        }
    }
}
</script>

<style lang="scss">
    .software-requests .text h4 {        
        line-height: 30px!important;        
    }
</style>

<style lang="scss" scoped>
    
    label.confirmation {
        padding:1rem;
        font-size:1.8rem;
        input {
            position: relative;
            left:.5rem;
            top:2px;
            cursor:pointer;
        }
    }
    ul.software {
        li {
            display: flex;
            align-items:center;
            padding:2rem;
            & > div {
                width:50%;
                display:flex;
                align-items: center;
            }
            img {
                width:80px;
                margin-right:1rem;
            }
        }
    }

    .select-software {
        max-width: 220px;
    }

    .subtotal {
        padding:2rem;
        display:flex;
        align-items:center;
        justify-content: space-between;
    }
 
    .text {
        padding:2rem 1rem;
       
    }
</style>



// WEBPACK FOOTER //
// SoftwareRequests.vue?da3a0d72